import React from "react"
import './footer.css';

export const HomeFooter = () => {


  return (
    <footer
      className="Layout__Footer HomeFooter"
    >
      <div>Future Education and Literacy for Designers (ERASMUS +)</div>
      <a target="_blank" rel="noopener noreferrer"  href="http://fuel4design.org/index.php/design-futures-lexicon">Go to the Design Futures Lexicon</a>

    </footer>
  )

}

export const ModeFooter = () => {

  return (
    <footer
      className="Layout__Footer ModeFooter"
    >
      <div className="CTA">I need some help: <a className="button" target="_blank" rel="noopener noreferrer"  href="https://vimeo.com/402124622">SEE THE VIDEO TUTORIAL</a></div>
      <div className="CTA">I’m done with the REFLEXICON: <a className="button" target="_blank" rel="noopener noreferrer"  href="http://reflexicon.design-friction.com">I SHARE MY FEEDBACK!</a></div>
    </footer>
  )

}